// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResyncClientEntitiesMutationVariables = Types.Exact<{
  kind?: Types.InputMaybe<Types.IntegrationProvider>;
}>;


export type ResyncClientEntitiesMutation = { __typename?: 'Mutation', syncIntegrationClientsAndEntities: string };

export const Operations = {
  Mutation: {
    ResyncClientEntities: 'ResyncClientEntities' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const ResyncClientEntitiesDocument = gql`
    mutation ResyncClientEntities($kind: IntegrationProvider) {
  syncIntegrationClientsAndEntities(kind: $kind)
}
    `;
export type ResyncClientEntitiesMutationFn = Apollo.MutationFunction<ResyncClientEntitiesMutation, ResyncClientEntitiesMutationVariables>;

/**
 * __useResyncClientEntitiesMutation__
 *
 * To run a mutation, you first call `useResyncClientEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResyncClientEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resyncClientEntitiesMutation, { data, loading, error }] = useResyncClientEntitiesMutation({
 *   variables: {
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useResyncClientEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<ResyncClientEntitiesMutation, ResyncClientEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResyncClientEntitiesMutation, ResyncClientEntitiesMutationVariables>(ResyncClientEntitiesDocument, options);
      }
export type ResyncClientEntitiesMutationHookResult = ReturnType<typeof useResyncClientEntitiesMutation>;
export type ResyncClientEntitiesMutationResult = Apollo.MutationResult<ResyncClientEntitiesMutation>;
export type ResyncClientEntitiesMutationOptions = Apollo.BaseMutationOptions<ResyncClientEntitiesMutation, ResyncClientEntitiesMutationVariables>;